import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http2"
import {getProductsFragmentByPage} from "../../api/getProductsFragmentByPage"
import {SearchApiRequestTypes} from "../../config/constants"
import {ExternalSearchApiResponse} from "../../models/searchApi"
import {SearchState, BloomreachCookiesInitialVal} from "../../models/SearchState"
import {mapProductsFragmentToItems} from "../productsFragment"
import redirectErrorPage from "../redirectErrorPage"
import {urlSanitiser} from "../httpUrlTrimmer"
import {getSearchResults} from "../../api/getSearchResults"

const getFacetSearchResults = async (
    searchUrl: string,
    siteUrl: string,
    headers: IncomingHttpHeaders,
    searchTerm: string | null,
    type: SearchApiRequestTypes,
    lazyloadItemIndexFrom: number,
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal,
    bloomreachPersonalizationEnabled: boolean,
    apiProxyVersion: string,
    enableNewProductSummary: boolean,
    bloomreachDefaultProviderArgs: string,
): Promise<Pick<SearchState, "totalResults" | "facets" | "filtersSort" | "filters">> => {
    try {
        const fields: (keyof ExternalSearchApiResponse)[] = ["totalResults", "filters"]

        let getFragments
        if (enableNewProductSummary) getFragments = getSearchResults
        else getFragments = getProductsFragmentByPage

        const apiResponse = await getFragments({
            url: searchUrl,
            baseUrl: urlSanitiser(siteUrl),
            headers,
            searchTerm,
            type,
            pageSize: 1,
            bloomreachCookiesInitialVal,
            bloomreachPersonalizationEnabled,
            pageLoadTrigger: "NEXT",
            fields,
            sliceSize: 0,
            start: 0,
            apiProxyVersion,
            bloomreachDefaultProviderArgs,
        })

        const {totalResults, filters, filtersSort, facets} = mapProductsFragmentToItems(
            apiResponse,
            lazyloadItemIndexFrom,
        ).searchStateData as any

        return {
            totalResults,
            filters,
            filtersSort,
            facets,
        }
    } catch (error) {
        window.location.href = `${redirectErrorPage(siteUrl)}`
        logger.error(error, "search-for-selected-assets-error")
        throw error
    }
}

export default getFacetSearchResults
